import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import Application from './pages/Application';
import './assets/css/main.css';

ReactDOM.render(<Application />, document.getElementById('root'));
